import React, { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { Form } from "../../styles/GlobalStyles";
import {
  CourseDiv,
  InputContainer,
  InputContainerCourse,
  InputContainerYear,
} from "./styled";
import api from "../../api/axios";
import { toast } from "react-toastify";
import { ACADEMIC_LIST } from "../../constants/academic";

export const CreateNewEducationModal = ({
  open,
  onClose,
  educationData,
  userId,
}) => {
  const [values, setValues] = useState({
    educationLevel: educationData?.educationLevel,
    course: educationData?.course || "",
    year: educationData?.year || "",
  });

  const handleSubmit = async () => {
    try {
      await api.put(`/professional/update/${userId}`, {
        academicLevel: values,
      });
      resetValues();
      onClose();
    } catch (error) {
      toast.error(error);
    }
  };

  const handleClose = () => {
    resetValues();
    onClose();
  };

  const resetValues = () => {
    setValues({
      educationLevel: "",
      course: "",
      year: "",
    });
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "700px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">Editar Formação</DialogTitle>
      <DialogContent>
        <Form>
          <Stack
            sx={{
              width: "100%",
              minWidth: "300px",
              gap: "1.5rem",
            }}
          >
            <InputContainer>
              <label for="education-level">Tipo:</label>
              <Select
                id="education-level"
                name="education-level"
                value={values.educationLevel}
                onChange={(e) =>
                  setValues({ ...values, educationLevel: e.target.value })
                }
              >
                {ACADEMIC_LIST.map((item) => (
                  <MenuItem value={item}>{item}</MenuItem>
                ))}
              </Select>
            </InputContainer>
            {values.educationLevel &&
            !values.educationLevel.includes("Ensino Médio") ? (
              <>
                <InputContainer>
                  <label for="local">Local:</label>
                  <input
                    id="local"
                    name="local"
                    type="text"
                    value={values.local}
                    onChange={(e) =>
                      setValues({ ...values, local: e.target.value })
                    }
                  />
                </InputContainer>
                <CourseDiv>
                  <InputContainerCourse>
                    <label for="course">Curso:</label>
                    <input
                      id="course"
                      name="course"
                      type="text"
                      value={values.course}
                      onChange={(e) =>
                        setValues({ ...values, course: e.target.value })
                      }
                    />
                  </InputContainerCourse>
                  <InputContainerYear>
                    <label for="year">Ano:</label>
                    <input
                      id="year"
                      name="year"
                      type="text"
                      value={values.year}
                      onChange={(e) =>
                        setValues({ ...values, year: e.target.value })
                      }
                    />
                  </InputContainerYear>
                </CourseDiv>
              </>
            ) : (
              <></>
            )}
          </Stack>
        </Form>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          sx={{ backgroundColor: "#104467", color: "white" }}
          onClick={handleSubmit}
          variant="contained"
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
